import { render } from "./CriterionGroup.vue?vue&type=template&id=53f4a710&scoped=true"
import script from "./CriterionGroup.vue?vue&type=script&lang=js"
export * from "./CriterionGroup.vue?vue&type=script&lang=js"

import "./CriterionGroup.vue?vue&type=style&index=0&id=53f4a710&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f4a710"]])

export default __exports__